const slideshowEventName = {
  START: 'Start',
  PAUSE: 'Pause',
  SLIDE_NEXT: 'Next',
  SLIDE_BACK: 'Back',
  DRAWER_NEXT: 'ClickGalleryNext',
  DRAWER_BACK: 'ClickGalleryBack',
  PAGE_VIEW: 'ImageView'
};

const SLIDESHOW_EVENT_CATEGORY = 'slideshow';

const CUSTOM_SLIDESHOW_EVENT_NAME_PREFIX = 'slideshow_';

const DEFAULT_SLIDESHOW_EVENT_NAME = 'analytics-slideshow';

const triggerEvent = (eventName = '', eventMeta) => {
  if (window && window['Worldnow']) {
    const Worldnow = window['Worldnow'];

    Worldnow.EventMan.event(eventName, eventMeta);
  }
};

const triggerSlideshowEvent = (eventName, { slideshowData = {}, index = 0, numberOfItems = 0 }) => {
  const {
    widgetId = '',
    widgetHeadline,
    adTag,
    url: imageUrl = '',
    headline: imageHeadline
  } = slideshowData;

  const eventMeta = {
    event_action: eventName,
    event_name: eventName.toLowerCase(),
    category: SLIDESHOW_EVENT_CATEGORY,
    page_url: document.location.href,
    slideshow_headline: widgetHeadline, // headline / title of slideshow
    slideshow_widgetid: widgetId, // slideshow widgetid
    slideshow_widgetheadline: widgetHeadline, // headline / title of slideshow
    slideshow_adtag: adTag, //content classification
    slideshow_imageid: imageUrl, // current image url
    slideshow_imageindex: index, // counter/index of image
    slideshow_imagename: imageHeadline, // caption of image -- title
    slideshow_count: numberOfItems // number of items in slideshow
  };

  triggerEvent(`${CUSTOM_SLIDESHOW_EVENT_NAME_PREFIX}${eventName.toLowerCase()}`, eventMeta);
  triggerEvent(DEFAULT_SLIDESHOW_EVENT_NAME, eventMeta);
};

const triggerSlideshowPageView = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.PAGE_VIEW, metaData);
};

const triggerSlideshowSlideNext = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.SLIDE_NEXT, metaData);
};

const triggerSlideshowSlideBack = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.SLIDE_BACK, metaData);
};

const triggerSlideshowDrawerNext = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.DRAWER_NEXT, metaData);
};

const triggerSlideshowDrawerBack = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.DRAWER_BACK, metaData);
};

const triggerSlideshowStart = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.START, metaData);
};

const triggerSlideshowPause = (metaData) => {
  triggerSlideshowEvent(slideshowEventName.PAUSE, metaData);
};

export { triggerSlideshowPageView, triggerSlideshowSlideNext, triggerSlideshowSlideBack, triggerSlideshowDrawerNext, triggerSlideshowDrawerBack, triggerSlideshowStart, triggerSlideshowPause };



// WEBPACK FOOTER //
// ./app/utils/AnalyticsUtils.js